<template>
    <div class="author-info" @click.prevent>
        <img :src="author.image_path" v-if="author.image_path" @click.stop="$emit('open-author', author)"/>
        <img src="@/assets/images/portrait/small/avatar-default.jpg" v-if="!author.image_path" @click.stop="$emit('open-author', author)"/>
        <div class="name-author pl-2 cursor-pointer link" @click.stop="$emit('open-author', author)">
        <!-- <span class="bypwd">{{ $t('NEWS_DETAIL').By}}</span>  -->
        <span class="text-name-author" v-if="displayName">{{ author.name }}</span>
        <span class="text-name-author" v-if="displayNickname">{{ author.nickname? author.nickname : author.name }}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    author: {
        type: Object,
        require: true
    },
    displayName: {
      type: Boolean,
      default: false
    },
    displayNickname: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style>
</style>